import axios from 'axios';

// Standalone axios instance for the vendor recipient portal -- deliberately separate from
// ../../services/api.ts, which attaches a tenant Bearer token from localStorage['access_token']
// and force-redirects to /login on 401. A portal recipient has no tenant account at all, so this
// instance reads a differently-named localStorage key (portal_access_token) and, on a 401,
// clears only that key and sends the recipient to the portal's own login page -- never the
// tenant app's /login.

const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const API_BASE = isDevelopment ? 'http://localhost:8060/api' : '/api';

export const PORTAL_TOKEN_KEY = 'portal_access_token';
export const PORTAL_ACCOUNT_KEY = 'portal_account';

const portalApi = axios.create({ baseURL: API_BASE, headers: { 'Content-Type': 'application/json' } });

portalApi.interceptors.request.use(config => {
  const token = localStorage.getItem(PORTAL_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

portalApi.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem(PORTAL_TOKEN_KEY);
      localStorage.removeItem(PORTAL_ACCOUNT_KEY);
    }
    return Promise.reject(error);
  }
);

export default portalApi;

export const apiError = (error: any, fallback: string) => error?.response?.data?.detail || fallback;
